/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "antd";
import React, { Fragment, PropsWithChildren, ReactNode } from "react";

interface ButtonFieldProps extends PropsWithChildren {
  text: string | JSX.Element | undefined;
  type: "primary" | "dashed" | "link" | "text" | "default";
  className?: string;
  onClick?: (arg: any) => void;
  icon?: ReactNode;
  shape?: "default" | "circle" | "round";
  size?: "large" | "middle" | "small";
  disabled?: boolean;
  danger?: boolean;
  loading?: boolean | { delay: number };
  block?: boolean;
  styles?: object;
  htmlType?: "button" | "submit" | "reset" | undefined;
  form?: string;
}

const defaultProps: ButtonFieldProps = {
  text: "",
  type: "text",
  onClick: () => {},
  disabled: false,
  danger: false,
  loading: false,
  block: false,
};

const ButtonField: React.FC<ButtonFieldProps> = (props) => {
  const {
    text,
    className,
    styles,
    type,
    icon,
    shape,
    size,
    disabled,
    danger,
    loading,
    block,
    htmlType,
    onClick,
    form,
  } = props;

  return (
    <Fragment>
      <Button
        type={type}
        className={`${className} grn-common-btn`}
        style={styles}
        icon={icon}
        shape={shape}
        size={size}
        disabled={disabled}
        danger={danger}
        loading={loading}
        block={block}
        htmlType={htmlType}
        onClick={onClick}
        form={form}
      >
        {text}
      </Button>
    </Fragment>
  );
};

ButtonField.defaultProps = defaultProps;

export default ButtonField;
